import { Button } from "@/components/ui/button";
import { Crown } from "lucide-react";
import { useIsNativeApp } from "@/hooks/useIsNativeApp";

interface MidPageCTAProps {
  onStartTrial: () => void;
  isAlreadyMember: boolean;
}

const MidPageCTA = ({ onStartTrial, isAlreadyMember }: MidPageCTAProps) => {
  const isNativeApp = useIsNativeApp();
  if (isNativeApp) return null;

  return (
    <section className="py-16">
      <div className="container mx-auto px-6 text-center space-y-4">
        <Button
          onClick={onStartTrial}
          disabled={isAlreadyMember}
          size="lg"
          className="bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90 text-primary-foreground font-semibold text-lg px-8 py-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        >
          <Crown className="w-5 h-5 mr-2" />
          {isAlreadyMember ? "Du bist bereits Mitglied" : "Jetzt 2 Wochen für 1 € testen"}
        </Button>
        <p className="text-sm text-muted-foreground">
          Jederzeit kündbar · Keine versteckten Kosten
        </p>
      </div>
    </section>
  );
};

export default MidPageCTA;
